// extracted by mini-css-extract-plugin
module.exports = {"d2xTeaser":"teaser_eu_d2xTeaser__x_U_6"};